import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Epaper/EpaperFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/Epaper/EpaperHeader.tsx");
